import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
   FaSearch, FaHashtag, FaPaintBrush,
   FaEnvelope, FaWhatsapp,
  FaCheckCircle, FaClock,
  FaCog, FaLightbulb,
  FaGlobe,
  FaTag, FaCalendar, FaMoneyBillWave,
  FaTimes,  FaCogs,
  FaShoppingCart,FaFileAlt,
  FaArrowRight
} from 'react-icons/fa';



const SERVICES_DATA = [
  {
    id: 'web-dev',
    icon: <FaGlobe className="w-8 h-8" />,
    title: 'Web Development',
    desc: 'Custom, mobile-friendly websites built to convert visitors into customers.',
    features: ['Responsive Design', 'SEO-Optimized', 'E-commerce', 'CMS Integration'],
    color: '#2563eb',
    stats: ['98% Client Satisfaction', '40% Faster Load Times'],
    details: {
      overview: "Transform your online presence with custom-built websites that combine stunning design with powerful functionality. From simple business sites to complex e-commerce platforms, we build for performance and conversion.",
      process: [
        'Discovery & Strategy',
        'Wireframing & Design',
        'Development & Integration',
        'Testing & Launch',
        'Training & Handover',
        'Ongoing Support'
      ],
      packages: [
        {
          name: 'Starter',
          price: 'KSh 25,000',
          features: ['5 Pages', 'Mobile Responsive', 'Basic SEO', 'Contact Form', '1 Month Support'],
          popular: false
        },
        {
          name: 'Professional',
          price: 'KSh 60,000',
          features: ['Up to 15 Pages', 'CMS Integration', 'Advanced SEO', 'E-commerce Ready', '3 Months Support'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: 'Custom Quote',
          features: ['Custom Features', 'API Integrations', 'Priority Support', 'Maintenance', 'Training'],
          popular: false
        }
      ],
      technologies: ['React/Next.js', 'Node.js', 'WordPress', 'Shopify', 'MongoDB'],
      timeline: '2-8 weeks',
      benefits: [
        'Increased visibility',
        'Higher conversions',
        'Scalable architecture',
        'Mobile-first approach'
      ]
    }
  },
  {
    id: 'seo',
    icon: <FaSearch className="w-8 h-8" />,
    title: 'SEO Strategy',
    desc: 'Get found on Google and attract qualified leads with data-driven SEO.',
    features: ['Keyword Research', 'Technical SEO', 'Local SEO', 'Content Optimization'],
    color: '#10b981',
    stats: ['Avg 3.2x ROI', 'Top 3 Rankings'],
    details: {
      overview: "Dominate search results with strategies built for the Kenyan market. We focus on sustainable growth through technical excellence, quality content, and local search visibility.",
      process: [
        'Technical Audit',
        'Keyword Strategy',
        'On-Page Optimization',
        'Content Development',
        'Link Building',
        'Performance Tracking'
      ],
      packages: [
        {
          name: 'Basic',
          price: 'KSh 15,000/mo',
          features: ['Keyword Research', 'On-Page SEO', 'Monthly Reports', 'Google Analytics'],
          popular: false
        },
        {
          name: 'Advanced',
          price: 'KSh 25,000/mo',
          features: ['Technical SEO', 'Content Strategy', 'Local SEO', 'Competitor Analysis'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: 'Custom Quote',
          features: ['Full Campaign', 'International SEO', 'Video SEO', 'ROI Tracking'],
          popular: false
        }
      ],
      technologies: ['Google Analytics', 'SEMrush', 'Ahrefs', 'Google Search Console', 'Screaming Frog'],
      timeline: '3-6 months for full results',
      benefits: [
        'Higher organic traffic',
        'Better conversion rates',
        'Competitive advantage',
        'Sustainable growth'
      ]
    }
  },
  {
    id: 'social-media',
    icon: <FaHashtag className="w-8 h-8" />,
    title: 'Social Media',
    desc: 'Strategic content and campaigns that engage your audience and drive sales.',
    features: ['Content Strategy', 'Community Management', 'Paid Ads', 'Analytics & Reporting'],
    color: '#8b5cf6',
    stats: ['50%+ Engagement', '10K Followers/Month'],
    details: {
      overview: "Build a loyal community and drive revenue through strategic social media management. From organic growth to targeted advertising, we create campaigns that resonate.",
      process: [
        'Social Audit',
        'Strategy Development',
        'Content Creation',
        'Community Engagement',
        'Paid Advertising',
        'Performance Analysis'
      ],
      packages: [
        {
          name: 'Growth',
          price: 'KSh 20,000/mo',
          features: ['3 Platforms', '15 Posts/Month', 'Basic Engagement', 'Monthly Reports'],
          popular: false
        },
        {
          name: 'Pro',
          price: 'KSh 50,000/mo',
          features: ['5 Platforms', '30 Posts/Month', 'Paid Ads Mgmt', 'Weekly Reports'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: 'Custom Quote',
          features: ['Unlimited Platforms', 'Content Creation', 'Influencer Collabs', 'Crisis Mgmt'],
          popular: false
        }
      ],
      technologies: ['Meta Business', 'Hootsuite', 'Canva', 'Later', 'Buffer', 'Sprout Social'],
      timeline: 'Ongoing monthly',
      benefits: [
        'Brand awareness',
        'Higher engagement',
        'Direct communication',
        'Data-driven optimization'
      ]
    }
  },
  {
    id: 'brand-design',
    icon: <FaPaintBrush className="w-8 h-8" />,
    title: 'Brand Design',
    desc: 'Cohesive visual identity that tells your story and builds recognition.',
    features: ['Logo Design', 'Brand Guidelines', 'Marketing Materials', 'UI/UX Design'],
    color: '#f59e0b',
    stats: ['2x Brand Recall', 'Professional Impact'],
    details: {
      overview: "Create a memorable brand identity that connects with your audience. We develop cohesive visual systems that communicate your values and differentiate you from competitors.",
      process: [
        'Brand Discovery',
        'Mood Board Creation',
        'Logo Concepts',
        'Brand Application',
        'Style Guide',
        'Asset Delivery'
      ],
      packages: [
        {
          name: 'Logo Package',
          price: 'KSh 5,000',
          features: ['3 Concepts', 'Color Palette', 'Typography', 'Final Files'],
          popular: false
        },
        {
          name: 'Brand Identity',
          price: 'KSh 20,000',
          features: ['Complete System', 'Brand Guidelines', 'Social Media Kit', 'Business Cards'],
          popular: true
        },
        {
          name: 'Full Branding',
          price: 'Custom Quote',
          features: ['Website Design', 'Packaging', 'Marketing Collateral', 'Brand Launch'],
          popular: false
        }
      ],
      technologies: ['Adobe Creative Suite', 'Figma', 'Sketch', 'InVision', 'Procreate'],
      timeline: '2-4 weeks',
      benefits: [
        'Stronger recognition',
        'Consistent identity',
        'Professional presence',
        'Customer trust'
      ]
    }
  },
  {
    id: 'email-marketing',
    icon: <FaEnvelope className="w-8 h-8" />,
    title: 'Email Marketing',
    desc: 'Automated sequences that nurture leads and turn them into loyal customers.',
    features: ['List Building', 'Automation Flows', 'A/B Testing', 'Performance Analytics'],
    color: '#ec4899',
    stats: ['78% More Leads', '35% Open Rates'],
    details: {
      overview: "Convert leads into customers with targeted email campaigns. We build automated sequences that nurture relationships and drive sales at every stage of the customer journey.",
      process: [
        'Audience Segmentation',
        'Template Design',
        'Automation Setup',
        'Content Development',
        'A/B Testing',
        'Optimization'
      ],
      packages: [
        {
          name: 'Setup',
          price: 'KSh 3,000',
          features: ['Template Design', 'List Setup', 'Welcome Sequence', 'Basic Analytics'],
          popular: false
        },
        {
          name: 'Automation',
          price: 'KSh 25,000',
          features: ['5 Flows', 'Segmentation', 'A/B Testing', 'Monthly Reports'],
          popular: true
        },
        {
          name: 'Managed',
          price: 'KSh 10,000/mo',
          features: ['Unlimited Campaigns', 'Content Creation', 'Optimization', 'Strategy Updates'],
          popular: false
        }
      ],
      technologies: ['Mailchimp', 'ConvertKit', 'Klaviyo', 'ActiveCampaign', 'HubSpot'],
      timeline: '2-4 weeks setup',
      benefits: [
        'Higher conversions',
        'Automated nurturing',
        'Personalized journeys',
        'Measurable results'
      ]
    }
  },
  {
    id: 'ecommerce',
    icon: <FaShoppingCart className="w-8 h-8" />,
    title: 'E-commerce',
    desc: 'Complete online stores with payment integration and inventory management.',
    features: ['Store Setup', 'Payment Gateways', 'Inventory Management', 'Mobile Optimized'],
    color: '#3b82f6',
    stats: ['Avg 3.5x Sales', '24/7 Support'],
    details: {
      overview: "Launch and scale your online store with comprehensive e-commerce solutions. From platform selection to payment integration, we handle everything.",
      process: [
        'Platform Selection',
        'Product Catalog',
        'Payment Integration',
        'Shipping Setup',
        'Mobile Optimization',
        'Launch & Marketing'
      ],
      packages: [
        {
          name: 'Starter',
          price: 'KSh 45,000',
          features: ['50 Products', 'Basic Design', 'Payment Integration', 'Mobile Responsive'],
          popular: false
        },
        {
          name: 'Advanced',
          price: 'KSh 75,000',
          features: ['Unlimited Products', 'Custom Design', 'Multi-currency', 'Inventory Mgmt'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: 'Custom Quote',
          features: ['Custom Features', 'ERP Integration', 'Mobile App', 'Priority Support'],
          popular: false
        }
      ],
      technologies: ['Shopify', 'WooCommerce', 'Magento', 'PayPal', 'M-Pesa', 'Stripe'],
      timeline: '3-6 weeks',
      benefits: [
        '24/7 sales',
        'Secure payments',
        'Scalable platform',
        'Integrated management'
      ]
    }
  },
  {
    id: 'content-marketing',
    icon: <FaFileAlt className="w-8 h-8" />,
    title: 'Content Marketing',
    desc: 'Strategic content that drives traffic, builds authority, and generates leads.',
    features: ['Blog Strategy', 'Video Content', 'Case Studies', 'Content Calendar'],
    color: '#8b5cf6',
    stats: ['3x More Traffic', 'Higher Authority'],
    details: {
      overview: "Establish your brand as an industry authority with strategic content marketing. We create valuable, engaging content that attracts, educates, and converts.",
      process: [
        'Content Audit',
        'Topic Research',
        'Content Creation',
        'Optimization',
        'Distribution',
        'Performance Review'
      ],
      packages: [
        {
          name: 'Starter',
          price: 'KSh 25,000/mo',
          features: ['4 Blog Posts', 'Basic Strategy', 'Social Content', 'Monthly Report'],
          popular: false
        },
        {
          name: 'Pro',
          price: 'KSh 40,000/mo',
          features: ['8 Pieces', 'Video Content', 'Content Calendar', 'Weekly Optimization'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: 'Custom Quote',
          features: ['Full Suite', 'Case Studies', 'Influencer Content', 'ROI Tracking'],
          popular: false
        }
      ],
      technologies: ['WordPress', 'Canva', 'Adobe Premiere', 'Grammarly', 'BuzzSumo'],
      timeline: 'Ongoing monthly',
      benefits: [
        'More traffic',
        'Higher rankings',
        'Brand authority',
        'Cost-effective leads'
      ]
    }
  },
  {
    id: 'custom-systems',
    icon: <FaCogs className="w-8 h-8" />,
    title: 'Custom Systems',
    desc: 'Tailored business systems and CRM solutions built for your operations.',
    features: ['CRM Development', 'CMS Solutions', 'API Integration', 'Process Automation'],
    color: '#64748b',
    stats: ['Streamlined Operations', 'Time Savings'],
    details: {
      overview: "Streamline your operations with custom-built digital systems. From client management portals to inventory tracking, we build solutions that fit your workflow.",
      process: [
        'Requirements Analysis',
        'System Architecture',
        'Development Sprints',
        'User Testing',
        'Deployment',
        'Training & Support'
      ],
      packages: [
        {
          name: 'Consultation',
          price: 'KSh 10,000',
          features: ['Requirements Analysis', 'System Design', 'Project Roadmap', 'Cost Estimate'],
          popular: false
        },
        {
          name: 'Development',
          price: 'From KSh 80,000',
          features: ['Custom Development', 'Database Design', 'User Training', '3 Months Support'],
          popular: true
        },
        {
          name: 'Managed',
          price: 'Custom Quote',
          features: ['Full Development', 'Ongoing Maintenance', 'Feature Updates', 'Priority Support'],
          popular: false
        }
      ],
      technologies: ['React', 'Node.js', 'PostgreSQL', 'MongoDB', 'AWS', 'Docker'],
      timeline: '4-12 weeks',
      benefits: [
        'Streamlined operations',
        'Time savings',
        'Data centralization',
        'Scalable infrastructure'
      ]
    }
  }
];


// ===========================================
// COMPONENTS
// ===========================================

const ServiceCard = ({ service, index, onClick }) => (
  <motion.div
    initial={{ y: 30, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ delay: index * 0.1 }}
    whileHover={{ y: -10 }}
    onClick={() => onClick(service)}
    className="group cursor-pointer bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent overflow-hidden relative"
  >
    {/* Top gradient bar */}
    <div 
      className="absolute top-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
      style={{ background: `linear-gradient(90deg, ${service.color}, ${service.color}cc)` }}
    />
    
    <div className="p-8">
      <div className="flex items-start justify-between mb-6">
        <div 
          className="w-16 h-16 rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500"
          style={{ backgroundColor: `${service.color}15` }}
        >
          <div style={{ color: service.color }}>{service.icon}</div>
        </div>
        <div className="flex flex-col gap-2 items-end">
          {service.stats.map((stat, idx) => (
            <span 
              key={idx}
              className="text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap"
              style={{ 
                backgroundColor: `${service.color}10`,
                color: service.color
              }}
            >
              {stat}
            </span>
          ))}
        </div>
      </div>
      
      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#010536] transition-colors duration-300">
        {service.title}
      </h3>
      <p className="text-gray-600 leading-relaxed mb-5 line-clamp-2">
        {service.desc}
      </p>
      
      <div className="grid grid-cols-2 gap-3 mb-6">
        {service.features.slice(0, 4).map((feature, fIndex) => (
          <div key={fIndex} className="flex items-center gap-2">
            <FaCheckCircle className="flex-shrink-0 text-sm" style={{ color: service.color }} />
            <span className="text-sm text-gray-700">{feature}</span>
          </div>
        ))}
      </div>
      
      <button 
        className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 flex items-center justify-center gap-2 hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]"
        style={{ 
          background: `linear-gradient(135deg, ${service.color} 0%, ${service.color}dd 100%)`,
        }}
      >
        Learn More
        <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
      </button>
    </div>
  </motion.div>
);

const SectionHeader = ({ badgeText, badgeIcon, title, subtitle }) => (
  <motion.div
    initial={{ y: 20, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true }}
    className="text-center mb-16"
  >
    <span className="inline-flex items-center text-xs font-semibold uppercase tracking-wider text-[#fdaa01] mb-4 px-4 py-2 bg-[#fdaa01]/10 rounded-full border border-[#fdaa01]/20">
      {badgeIcon}
      <span className="ml-2">{badgeText}</span>
    </span>
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4">{title}</h2>
    {subtitle && (
      <p className="text-lg text-white/70 max-w-2xl mx-auto">{subtitle}</p>
    )}
    <div className="w-24 h-1 bg-gradient-to-r from-[#fdaa01] to-transparent mx-auto mt-6" />
  </motion.div>
);

// Service Modal Component (Keep your existing modal but with improved styling)
const ServiceModal = ({ show, service, onClose }) => (
  <AnimatePresence>
    {show && service && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 50 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 50 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="bg-white rounded-3xl w-full max-w-5xl max-h-[90vh] overflow-y-auto shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div className="sticky top-0 bg-white border-b border-gray-100 p-6 sm:p-8 z-10 backdrop-blur-sm bg-white/95">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-center gap-4">
                <div 
                  className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg"
                  style={{ 
                    background: `linear-gradient(135deg, ${service.color}15, ${service.color}25)`,
                    border: `2px solid ${service.color}30`
                  }}
                >
                  <div style={{ color: service.color }}>{service.icon}</div>
                </div>
                <div>
                  <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{service.title}</h2>
                  <p className="text-gray-600 mt-1">{service.desc}</p>
                </div>
              </div>
              <button 
                onClick={onClose}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-all duration-300 flex-shrink-0 hover:rotate-90"
              >
                <FaTimes />
              </button>
            </div>
          </div>
          
          {/* Modal Body */}
          <div className="p-6 sm:p-8">
            {/* Overview */}
            <div className="mb-8 bg-gray-50 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div 
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <FaLightbulb style={{ color: service.color }} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Service Overview</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">{service.details.overview}</p>
            </div>
            
            {/* Benefits */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div 
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <FaCheckCircle style={{ color: service.color }} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Key Benefits</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {service.details.benefits.map((benefit, index) => (
                  <motion.div 
                    key={index} 
                    className="flex items-center gap-3 bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all duration-300"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <FaCheckCircle className="flex-shrink-0" style={{ color: service.color }} />
                    <span className="text-gray-700">{benefit}</span>
                  </motion.div>
                ))}
              </div>
            </div>
            
            {/* Process */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div 
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <FaCog style={{ color: service.color }} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Our Process</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {service.details.process.map((step, index) => (
                  <motion.div 
                    key={index} 
                    className="flex items-start gap-3 bg-white rounded-xl p-4 border border-gray-100 hover:shadow-md transition-all duration-300"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <div 
                      className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 shadow-md"
                      style={{ 
                        background: `linear-gradient(135deg, ${service.color}, ${service.color}dd)`
                      }}
                    >
                      {index + 1}
                    </div>
                    <span className="text-gray-700 text-sm">{step}</span>
                  </motion.div>
                ))}
              </div>
            </div>
            
            {/* Packages */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <div 
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${service.color}15` }}
                >
                  <FaMoneyBillWave style={{ color: service.color }} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Packages & Pricing</h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {service.details.packages.map((pkg, index) => (
                  <motion.div 
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className={`relative rounded-2xl p-6 border-2 transition-all duration-300 hover:shadow-xl ${
                      pkg.popular 
                        ? 'border-[#fdaa01] shadow-lg bg-gradient-to-b from-[#fdaa01]/5 to-white' 
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    {pkg.popular && (
                      <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#fdaa01] to-[#ffc042] text-[#010536] text-xs font-bold px-4 py-1.5 rounded-full shadow-lg">
                        Most Popular
                      </span>
                    )}
                    <h4 className="text-lg font-bold text-gray-900 mb-2">{pkg.name}</h4>
                    <div className="text-2xl font-extrabold mb-4" style={{ color: service.color }}>
                      {pkg.price}
                    </div>
                    <ul className="space-y-2 mb-6">
                      {pkg.features.map((feature, fIndex) => (
                        <li key={fIndex} className="flex items-center gap-2 text-sm text-gray-700">
                          <FaCheckCircle className="flex-shrink-0" style={{ color: service.color }} />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <a
                      href="https://wa.me/254762272152"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`block w-full py-3 rounded-xl text-center font-semibold transition-all duration-300 hover:shadow-lg ${
                        pkg.popular
                          ? 'bg-gradient-to-r from-[#fdaa01] to-[#ffc042] text-[#010536] hover:from-[#ffc042] hover:to-[#fdaa01]'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {pkg.popular ? 'Get Started Now' : 'Learn More'}
                    </a>
                  </motion.div>
                ))}
              </div>
            </div>
            
            {/* Technologies & Timeline */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div 
                    className="w-10 h-10 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${service.color}15` }}
                  >
                    <FaGlobe style={{ color: service.color }} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Technologies & Tools</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {service.details.technologies.map((tech, index) => (
                    <span 
                      key={index}
                      className="px-4 py-2 rounded-full text-sm font-semibold hover:scale-105 transition-transform duration-300"
                      style={{ 
                        backgroundColor: `${service.color}10`,
                        color: service.color,
                        border: `1px solid ${service.color}20`
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div 
                    className="w-10 h-10 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${service.color}15` }}
                  >
                    <FaCalendar style={{ color: service.color }} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Project Timeline</h3>
                </div>
                <div className="flex items-center gap-3 bg-white rounded-xl p-4 border border-gray-100">
                  <FaClock style={{ color: service.color }} />
                  <span className="text-gray-700 font-semibold">{service.details.timeline}</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Modal Footer */}
          <div className="sticky bottom-0 bg-white border-t border-gray-100 p-6 sm:p-8 flex flex-col sm:flex-row gap-4 justify-end backdrop-blur-sm bg-white/95">
            <button 
              onClick={onClose}
              className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200 transition-colors duration-300"
            >
              Close
            </button>
            <a
              href="https://wa.me/254762272152"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 rounded-xl bg-gradient-to-r from-[#fdaa01] to-[#ffc042] text-[#010536] font-semibold hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
            >
              <FaWhatsapp />
              Start Your Project
            </a>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

// ===========================================
// MAIN COMPONENT
// ===========================================

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedService(null);
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 300);
  };

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-br from-[#000324] via-[#010536] to-[#020a5c]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* Services Grid Section */}
      <section className="py-20 lg:py-28 relative">
        {/* Background decorative elements */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,rgba(253,170,1,0.08)_0%,transparent_50%),radial-gradient(circle_at_80%_20%,rgba(99,102,241,0.08)_0%,transparent_50%)]" />
        <div className="absolute top-40 left-10 w-64 h-64 bg-[#fdaa01]/5 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-40 right-10 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl animate-float [animation-delay:5s]" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader
            badgeText="Our Services"
            badgeIcon={<FaTag />}
            title="Comprehensive Digital Solutions"
            subtitle="From web development to digital strategy, we provide end-to-end solutions tailored to your business needs. Explore our services to discover how we can help you grow."
          />
          
          {/* Updated grid: 3 columns on large screens */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {SERVICES_DATA.map((service, index) => (
              <ServiceCard
                key={service.id}
                service={service}
                index={index}
                onClick={handleServiceClick}
              />
            ))}
          </div>
          
          {/* Bottom CTA */}
          <motion.div 
            className="text-center mt-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-white/70 text-lg mb-6">
              Not sure which service is right for you?
            </p>
            <a
              href="https://wa.me/254762272152"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 rounded-xl bg-gradient-to-r from-[#fdaa01] to-[#ffc042] text-[#010536] font-semibold shadow-lg shadow-[#fdaa01]/30 hover:shadow-xl hover:shadow-[#fdaa01]/40 hover:scale-105 transition-all duration-300"
            >
              <FaWhatsapp className="mr-2" />
              Get Free Consultation
            </a>
          </motion.div>
        </div>
      </section>

      {/* Service Modal */}
      <ServiceModal
        show={showModal}
        service={selectedService}
        onClose={handleCloseModal}
      />
    </motion.div>
  );
};

export default Services;